// components/ChatbotIcon.js
import React from "react";
import chatbotImage from "../assets/images/chatbot.png";
import useChatStore from "../store/useChatStore";

const ChatbotIcon = ({ toggleChat }) => {
  const { chatbotTheme } = useChatStore();
  return (
    <div
      onClick={toggleChat}
      style={{
        position: "fixed",
        bottom: "25px",
        right: "25px",
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        backgroundColor: chatbotTheme,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
      }}
    >
      <img
        src={chatbotImage}
        alt="chatbot"
        style={{ width: "35px", height: "35px" }}
      />
    </div>
  );
};

export default ChatbotIcon;
